import { render, staticRenderFns } from "./AddUpdateDeleteForm.vue?vue&type=template&id=c634cc1a&scoped=true&"
import script from "./AddUpdateDeleteForm.vue?vue&type=script&lang=js&"
export * from "./AddUpdateDeleteForm.vue?vue&type=script&lang=js&"
import style0 from "./AddUpdateDeleteForm.vue?vue&type=style&index=0&id=c634cc1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c634cc1a",
  null
  
)

export default component.exports